<template>
  <div></div>
</template>

<script>
import * as UserDevice from 'mobile-device-detect';
import url from 'url'

export default {
  name: 'Home',
  data() {
    return {
      userDevice: UserDevice
    }
  },
  methods: {
    redirect(shortenedUrl) {
      if (this.userDevice.isAndroid && shortenedUrl.android) {
        window.location.replace(this.convertUrl(shortenedUrl.android))
      } else if (this.userDevice.isIOS && shortenedUrl.ios) {
        window.location.replace(this.convertUrl(shortenedUrl.ios))
      } else {
        window.location.replace(this.convertUrl(shortenedUrl.url))
      }
    },
    convertUrl(originalUrl) {
      // No additional query params
      if (Object.keys(this.$route.query).length === 0) return originalUrl;

      let queries = [];
      Object.keys(this.$route.query).forEach(key => {
        queries.push(key + "=" + this.$route.query[key])
      })

      let parsedUrl = url.parse(originalUrl);

      if (parsedUrl.query) {
        return originalUrl + '&' + queries.join("&")
      } else {
        return originalUrl + '?' + queries.join("&")
      }
    },
    retrieveShortenedUrl() {
      this.$http.post("/v1/url-shortener/retrieveShortenedUrl", {
        data: {
          id: this.$route.params.id
        }
      }).then(response => {
        this.redirect(response.data.shortenedUrl)
      }).catch(() => {
        window.location.replace("https://www.ampoza.com/404")
      })
    }
  },
  created() {
    if (this.$route.params.id) {
      this.retrieveShortenedUrl()
    } else {
      window.location.replace("https://www.ampoza.com/404")
    }
  }
}
</script>

<style lang="less" scoped>
</style>
